import { jsx as u, Fragment as h, jsxs as p } from "react/jsx-runtime";
import { useState as y, useEffect as M } from "react";
import { Button as C } from "antd";
import "../../../../main/components/SimpleModal/index.js";
import { useSimpleModal as P } from "../../../../main/components/SimpleModal/hooks.js";
const k = (o) => {
  var d;
  const n = o == null ? void 0 : o.onConfirm, e = (o == null ? void 0 : o.initItems) || [], { show: l, close: r, modalProps: c, setModalProps: s } = P(), [t, i] = y([]), f = {
    title: "Bunny 媒體庫",
    footer: /* @__PURE__ */ u(h, { children: /* @__PURE__ */ p(C, { type: "primary", onClick: () => {
      r(), n == null || n(t);
    }, children: [
      "確定選取 (",
      t == null ? void 0 : t.length,
      ")"
    ] }) }),
    onCancel: r,
    destroyOnHidden: !0,
    ...c
  };
  return M(() => {
    i(e);
  }, [(d = e == null ? void 0 : e.map((m) => m.guid)) == null ? void 0 : d.join(",")]), {
    show: l,
    close: r,
    modalProps: f,
    setModalProps: s,
    selectedItems: t,
    setSelectedItems: i
  };
};
export {
  k as useMediaLibraryModal
};
